import { AppSpecifier } from "@data-root/types";
import { LoaderFunctionArgs, redirect } from "react-router";
import { core, coreConfig } from "@/index";
import { changeThemeColor } from "@/utils";
import * as Sentry from "@sentry/react";
import { getEmbedModeFlag, getStoredTokens } from "@/utils/tokenManager";
import { userFromMetadata } from "@/utils/userFromMetadata";

export const experimental_appScreenLoader = async (
  args: LoaderFunctionArgs
) => {
  const { appId, deploymentId, viewId } = args.params;

  const url = new URL(args.request.url);
  const token = url.searchParams.get("token");

  if (token) {
    await core.fromToken(token);
    if (core.user && core.user.id !== "guest") {
      await core.save();
    }
  } else if (getEmbedModeFlag()) {
    const stored = getStoredTokens();
    if (stored?.dataToken && stored?.user && Object.keys(stored.user).length > 0) {
      await core.fromToken(stored.dataToken);
      const user = userFromMetadata(stored.user ?? null);
      if (user) {
        core.user = user;
        core.authentication.user = core.user;
        core.authentication.identity = user.email;
        await core.save();
      } else {
        throw redirect("/auth");
      }
    } else {
      throw redirect("/embed");
    }
  } else {
    const stored = getStoredTokens();
    if (stored?.dataToken && stored?.user && Object.keys(stored.user).length > 0) {
      await core.fromToken(stored.dataToken);
      const user = userFromMetadata(stored.user ?? null);
      if (user) {
        core.user = user;
        core.authentication.user = core.user;
        core.authentication.identity = user.email;
        await core.save();
      } else {
        throw redirect("/auth");
      }
    } else {
      const recovered = await core
        .recover(coreConfig)
        .catch(() => false);
      if (!recovered || !core.user) {
        throw redirect("/auth");
      }
    }
  }

  // Verificación final: asegurar que tenemos un usuario válido
  if (!core.user || core.user.id === "guest") {
    console.warn("[appScreenLoader] No valid user found after authentication attempts");
    const newSearch = new URLSearchParams(url.searchParams);
    newSearch.set("next", url.pathname);

    const redirectUrl = `/auth?${newSearch.toString()}`;
    throw redirect(redirectUrl);
  }

  console.log("[appScreenLoader] User authenticated:", {
    userId: core.user.id,
    email: core.user.email,
  });

  Sentry.setUser({
    id: core.user!.id,
    username: core.user!.name,
    email: core.user!.email,
  });

  const appSpecifier: AppSpecifier = {
    appId,
    deploymentId,
  };

  await core.loadApp(appSpecifier);
  const { app } = await core.experimental_getApp(appSpecifier);

  if (!viewId && app.defaultViewId) {
    const defaultViewId = await core.evaluateFormula<string>(
      app.defaultViewId,
      {
        appId,
        deploymentId,
      }
    );

    if (defaultViewId)
      throw redirect(`/_/app/${appId}/${deploymentId}/${defaultViewId}`);
  }

  const { primaryColor } = app.styles;
  changeThemeColor(primaryColor);

  return { app };
};
